import { IntlShape } from 'react-intl';

const getPointsLabel = (points: number, formatMessage: IntlShape['formatMessage']) =>
  formatMessage({ id: 'crownsEarned' }, { points });

export default getPointsLabel;
